import { setUpFirstBlock } from './sections/first'
import { gsap } from 'gsap'


// calculate font size
function setMainFontSize(){
  let fontCoef = window.innerWidth / 1920
  let fontSize = Math.floor(100 * fontCoef)
  $('html').css('font-size', fontSize + '%')
}

if (window.innerWidth > 1500) {
  setMainFontSize()
  window.addEventListener('resize', function(event){
    setMainFontSize()
  });
}

let is_ios = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
if (is_ios) $('body').addClass('is-ios')
let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) $('body').addClass('is-safari')

// full vertical height for mobile devices, working with iphone bars   height: var(--app-height);
const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()



// Loader
let pageLoaded = 0
let minimumPreloadTimeCompleted = 0
let minimumPreloadTime = 600

function runPageLoadedFunctions(){
  if (!pageLoaded) return false
  if (!minimumPreloadTimeCompleted) return false

  setUpFirstBlock()

}

$(window).on('load', function (){
  pageLoaded = 1
  runPageLoadedFunctions()

  setTimeout(function (){
    $('body').attr('style', '')
  }, 100)

})

setTimeout(function (){
  minimumPreloadTimeCompleted = 1
  runPageLoadedFunctions()
}, minimumPreloadTime)






// load video mask and video
// let maskC = document.querySelector('.on-video-container')
// let imgUrl

// if (window.innerWidth > 1250){
//   imgUrl = maskC.getAttribute('data-img-src')
// } else if (window.innerWidth > 600 && window.innerWidth < 1250) {
//   imgUrl = maskC.getAttribute('data-img-tablet')
// } else {
//   imgUrl = maskC.getAttribute('data-img-phone')
// }
// maskC.style.backgroundImage = 'url('+imgUrl+')'
// maskC.style.backgroundSize = 'cover'
// maskC.style.backgroundPosition = 'center center'
//

